export default __webpack_public_path__ + "assets/wow.dd03f53e.gif";